import './index.less';
import axios from 'axios';
import React from 'react';
import { Upload, Icon, Message } from 'antd';
import { uploadImg, uploadHomework } from '../../api/index.js';

let tp
function randomString(len = 32) {
  const chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
  const maxPos = chars.length;
  let pwd = "";

  for (let i = 0; i < len; i += 1) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
}

function  getSuffix(filename) {
  const pos = filename.lastIndexOf(".");
  return pos !== -1 ? filename.substring(pos) : "";
}

function beforeUpload(file) {
  const newFile = file.file;
  if (newFile.type !== 'image/jpeg' && newFile.type !== 'image/png') {
    Message.error('请上传png或者jpg类型的图片!');
    return;
  }
  if (newFile.size / 1024 / 1024 > 2) {
    Message.error('请上传小于2M的图片!');
    return;
  }
  if (tp) {
    uploadHomework().then(res => {
      upload(file, res);
    })
    return;
  }
  uploadImg().then(res => {
    upload(file, res);
  })
}

function upload(file, res) {
  const key =
      res.output.dir + '/' +
      randomString() +
      getSuffix(file.file.name);
  let formData = new FormData();
  formData.append("key", key);
  formData.append("policy", res.output.policy);
  formData.append("OSSAccessKeyId", res.output.accessId);
  formData.append("success_action_status", "200");
  formData.append("signature", res.output.signature);
  formData.append("file", file.file);
  axios.post(res.output.host, formData, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
  .then(
    (res2) => {
      console.log(res2);
      file.onSuccess({ url: res.output.host_cdn + key + '!m', path: `/${key}` })
    },
    () => {}
  );
}

class Avatar extends React.Component {
  state = {
    loading: false,
  };

  success = (res) => {
    const { changeAvatar, type } = this.props;
    if (type) {
      changeAvatar({
        url: res.url,
        path: res.path
      });
      return
    }
    changeAvatar(res.url);
  }

  showImg = () => {
    const { url, type } = this.props;
    tp = type;
    if (type) {
      return <img src={url} alt="avatar" className='homework' />
    }
    return <img src={url} alt="avatar" className='avatar' />
  }

  render() {
    const uploadButton = (
      <div>
        <Icon type={this.state.loading ? 'loading' : 'plus'} />
      </div>
    );
    const { url, type } = this.props;
    return (
      <Upload
        name="avatar"
        listType="picture-card"
        className={type === 1 ? 'homework-uploader' : 'avatar-uploader'}
        showUploadList={false}
        onSuccess={this.success}
        customRequest={beforeUpload}
      >
        { url ? this.showImg() : uploadButton }
      </Upload>
    );
  }
}

export default Avatar


// WEBPACK FOOTER //
// ./src/components/upload/upload.jsx